<div class="main-container">
  <lib-ngx-data-table class="data-table" #datatable [rowHeight]="rowHeight" [data]="receiptCodesList"
    [columns]="columns" [selectionType]="undefined" [scrollbarH]="true" [scrollbarV]="true"
    (scroll)="onScroll($event)" />
  <app-receipt-code-filters #filtersPanel (search)="onSearch($event)"></app-receipt-code-filters>
</div>